module.exports = __webpack_public_path__ + "static/media/Attack Profile.459d6193.png";